import { render, staticRenderFns } from "./MyAdItemMotorhomeChips.vue?vue&type=template&id=88fafb5e&scoped=true"
import script from "./MyAdItemMotorhomeChips.vue?vue&type=script&lang=js"
export * from "./MyAdItemMotorhomeChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fafb5e",
  null
  
)

export default component.exports